"use client";

import React from "react";
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { redirect } from "next/navigation";
import { CheckAccountLockingDocument } from "./WithAccountLocking.generated";

export default function WithAccountLocking({
	children,
}: {
	children: React.ReactNode;
}) {
	const { data, loading } = useQuery(CheckAccountLockingDocument);
	if (!loading && data?.account?.isAccountLocked) {
		redirect("/account-locked");
	}

	return <>{children}</>;
}

gql`
	query CheckAccountLocking {
		account {
			isAccountLocked
		}
	}
`;
